import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  changeableItems: [],
  allChangeableItems: [],
  organizationName: null,
  selectedOrganizationId: null,
  isLoaded: false,
};

const changeableItemsSlice = createSlice({
  name: 'changeableItems',
  initialState,
  reducers: {
    setChangeableItems: (state, action) => {
      state.changeableItems = action.payload.changeableItems || [];
      state.organizationName = action.payload.organizationName || null;
      state.isLoaded = true;
    },
    setAllChangeableItems: (state, action) => {
      state.allChangeableItems = action.payload || [];
      state.isLoaded = true;
    },
    setSelectedOrganization: (state, action) => {
      state.selectedOrganizationId = action.payload;
      // Filter changeable items based on selected organization
      if (action.payload) {
        state.changeableItems = state.allChangeableItems.filter(
          item => item.organization_id === action.payload
        );
      } else {
        state.changeableItems = state.allChangeableItems;
      }
    },
    clearChangeableItems: (state) => {
      state.changeableItems = [];
      state.allChangeableItems = [];
      state.organizationName = null;
      state.selectedOrganizationId = null;
      state.isLoaded = false;
    },
  },
});

export const { setChangeableItems, setAllChangeableItems, setSelectedOrganization, clearChangeableItems } = changeableItemsSlice.actions;

// Selector to get changeable items
export const selectChangeableItems = (state) => state.changeableItems.changeableItems;

// Selector to get all changeable items
export const selectAllChangeableItems = (state) => state.changeableItems.allChangeableItems;

// Selector to get organization name
export const selectOrganizationName = (state) => state.changeableItems.organizationName;

// Selector to get selected organization ID
export const selectSelectedOrganizationId = (state) => state.changeableItems.selectedOrganizationId;

// Selector to check if changeable items are loaded
export const selectChangeableItemsLoaded = (state) => state.changeableItems.isLoaded;

// Selector to get unique organizations from all changeable items
export const selectOrganizations = (state) => {
  const items = state.changeableItems.allChangeableItems || [];
  const orgMap = new Map();
  items.forEach(item => {
    if (item.organization_id && item.organization_name) {
      orgMap.set(item.organization_id, item.organization_name);
    }
  });
  return Array.from(orgMap.entries()).map(([id, name]) => ({ id, name }));
};

export default changeableItemsSlice.reducer;